<div id="topHeader">
<h3>Impact Summary</h3>
{{numStations}} assets displayed.
</div>

<div style="clear:both">

<!-- header -->
<p-table #dt [value]="stationsArray" [scrollable]="true" scrollHeight="800px" [columns]="cols">
	<ng-template pTemplate="colgroup">
		<colgroup>
			<col>
			<col style="width:180px">  <!-- name -->
			<col>
			<col>
			<col>
			<col>
			<col style="width:150px"> <!-- dataType -->
			<col>
			<col>
			<col>
			<col>
			<col>
			<col>
			<col>
			<col>
			<col>
			<col>
		</colgroup>
	</ng-template>

	<!-- search filter -->
	<ng-template pTemplate="caption">
		<div style="text-align: right">        
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Search ID, Name, Basin or Type" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
	</ng-template>
 
    <ng-template pTemplate="header">
		<tr>
			<th colspan="6">Asset Data</th>
			<th></th>
			<th colspan="4">Observations<img src="assets/images/question-mark-icon.gif" title="{{this.dataTypeDescription}}"></th>
			<th colspan="3">Current Status</th>
			<th colspan="3">Forecast</th>
		</tr>
		<tr>
			<th>ID<br><input type="button" class="sortUpButton" (click)="sortById(1)" title="Sort ascending by id" /><br><input type="button" class="sortDownButton" (click)="sortById(-1)" title="Sort descending by id" /></th>
			<th>Name<br><input type="button" class="sortUpButton" (click)="sortByName(1)" title="Sort ascending by name" /><br><input type="button" class="sortDownButton" (click)="sortByName(-1)" title="Sort descending by name" /></th>
			<th>Basin<br><input type="button" class="sortUpButton" (click)="sortByBasin(1)" title="Sort ascending by basin" /><br><input type="button" class="sortDownButton" (click)="sortByBasin(-1)" title="Sort descending by basin" /></th>
			<th >Type</th>
			<th>Capacity</th>
			<!-- <p-column header="Street View"></p-column> -->
			<!-- <p-column header="Camera"></p-column> -->
			<th>Upstream Station</th>
			
			<th style="overflow:visible">Data Type<br>(sort by)<br>
				<p-select [options]="sortTypeList" [(ngModel)]="sortType" appendTo="body" [style]="{'min-width': '6em', 'width':'120px', 'overflow':'visible'}" [dropdownIcon]="caret"
					(ngModelChange)="newSortDataTypeSelected($event)" title="Data type on which to sort when sort buttons to the right are clicked (Last Week through Last 15 Minutes)">
					<ng-template let-sortType pTemplate="item">
						<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
	            			<div>{{sortType.label}}</div>
	        			</div>
					</ng-template>
				</p-select>
			</th>
			<th id="lastWeekColumn">Last Week<br> <input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('lastWeek', 1)" title="Sort ascending by selected data type ({{sortType}})" /><br><input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('lastWeek', -1)" title="Sort descending by selected data type ({{sortType}})" />
			</th>
			<th>Last Day<br>  <input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('lastDay', 1)" title="Sort ascending by selected data type ({{sortType}})" /><br><input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('lastDay', -1)" title="Sort descending by selected data type ({{sortType}})" />
			</th>
			<th>Last 3 Hours<br>  <input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('last3Hours', 1)" title="Sort ascending by selected data type ({{sortType}})" /><br><input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('last3Hours', -1)" title="Sort descending by selected data type ({{sortType}})" />
			</th>
			<th>Last Hour<br>  <input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('lastHour', 1)" title="Sort ascending by selected data type ({{sortType}})" /><br><input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('lastHour', -1)" title="Sort descending by selected data type ({{sortType}})" />
			</th>
			<th>Last 15 Mins<br>  <input type="button" class="sortUpButton" (click)="sortByDataTypeHelper('last15Minutes', 1)" title="Sort ascending by selected data type ({{sortType}})" /><br><input type="button" class="sortDownButton" (click)="sortByDataTypeHelper('last15Minutes', -1)" title="Sort descending by selected data type ({{sortType}})" />
			</th>
			<th>Alarm Status</th>			
			<th>Flood Threat<br><input type="button" class="sortDownButton" (click)="sortByThreat()" title="Sort descending by flood threat based on streamflow nova score" /></th>		
			<th>Next 6 Hours</th>			
			<th>Next Day</th>			
			<th>Next Week</th>	
		</tr>
		<tr>
			<th colspan="6"></th>
			<th>Weather</th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.lastWeek}} title={{this.weatherInfo.lastWeekMsg}}></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.lastDay}} title={{this.weatherInfo.lastDayMsg}}></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.last3Hours}} title={{this.weatherInfo.last3HoursMsg}}></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.lastHour}} title={{this.weatherInfo.lastHourMsg}}></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.last15Minutes}} title={{this.weatherInfo.last15MinutesMsg}}></a></th>	
			<th colspan="2"></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.next6Hours}} title={{this.weatherInfo.next6HoursMsg}}></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.nextDay}} title={{this.weatherInfo.nextDayMsg}}></a></th>
			<th><a href={{this.weatherInfo.providerURL}} target="_blank"><img src={{this.weatherInfo.nextWeek}} title={{this.weatherInfo.nextWeekMsg}}></a></th>
		</tr>
	</ng-template>


<!-- impact table data -->
<ng-template pTemplate="body" let-rowData>
	<tr>
	    <!-- ID -->
		<td>{{rowData.id}}</td>
		<!-- Name -->
	    <td>{{rowData.name}}</td>
		<!-- Basin -->
		<td>{{rowData.basin}}</td>
		<!-- Type -->
		<td>{{rowData.type}}</td>
		<!-- Capacity -->
		<!-- <td class="numbers">{{rowData.capacity}}</td> -->
		<td><tr><td class='numbers'>{{rowData.capacity}}</td></tr></td>
		<!-- Street View -->
		<!-- <p-column></p-column> -->
		<!-- Camera -->
		<!-- <p-column></p-column> -->
		<!-- Upstream Station -->
		<td styleClass="col-button" field="upstreamStationId" >
				<a routerLink="/stationDashboard//{{rowData.upstreamStationId}}" title="View upstream station {{rowData.upstreamStationId}} in the station dashboard">{{rowData.upstreamStationId}} Dashboard<i class="fa fa-link"></i></a>
		</td>
		
	    <!-- Data Type -->
		<td [style]="{'width':'150px'}">
		<!-- <td>  -->
			<span class="table-data">
			<tr><td><span *ngIf="rowData['hasData'].rain == true">Rain (in)</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].waterLevel == true">Water Level (ft)</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].streamflow == true">Streamflow (cfs)</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].wind == true">Wind (mph)</span></td></tr>
			</span>
		</td>
		<!-- Last Week -->
		<td>
			<span class="table-data numbers">
			<!--  This was working when each station had individual weather data
			<span class="top-line"><img  *ngIf="dat[col.field].weather < 10" src="images/clear.gif">   
					<img  *ngIf="dat[col.field].weather >= 10 && dat[col.field].weather < 20" src="images/partlycloudy.gif">
					<img  *ngIf="dat[col.field].weather >= 20 && dat[col.field].weather < 30" src="images/mostlycloudy.gif">
					<img  *ngIf="dat[col.field].weather >= 30" src="images/rain.gif"> </span><hr>
			-->
			<tr><td class='numbers'><span *ngIf="rowData.hasData.rain == true">{{rowData.lastWeek.rain}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].waterLevel == true">{{rowData.lastWeek.waterLevel}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].streamflow == true">{{rowData.lastWeek.streamflow}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].wind == true">{{rowData.lastWeek.wind}}</span></td></tr>
			</span>
		</td>		
		<!-- Last Day -->		
		<td>	
			<span class="table-data numbers">
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].rain == true">{{rowData.lastDay.rain}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].waterLevel == true">{{rowData.lastDay.waterLevel}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].streamflow == true">{{rowData.lastDay.streamflow}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].wind == true">{{rowData.lastDay.wind}}</span></td></tr>
			</span>
		</td>	
		<!-- Last 3 Hours -->		
		<td>
			<span class="table-data numbers">
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].rain == true">{{rowData.last3Hours.rain}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].waterLevel == true">{{rowData.last3Hours.waterLevel}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].streamflow == true">{{rowData.last3Hours.streamflow}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].wind == true">{{rowData.last3Hours.wind}}</span></td></tr>
			</span>
		</td>	
		<!-- Last Hour -->		
		<td>	
			<span class="table-data numbers">
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].rain == true">{{rowData.lastHour.rain}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].waterLevel == true">{{rowData.lastHour.waterLevel}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].streamflow == true">{{rowData.lastHour.streamflow}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].wind == true">{{rowData.lastHour.wind}}</span></td></tr>
			</span>
		</td>	
		<!-- Last 15 Mins -->		
		<td class="headerBackground">	
			<span class="table-data numbers">
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].rain == true">{{rowData.last15Minutes.rain}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].waterLevel == true">{{rowData.last15Minutes.waterLevel}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].streamflow == true">{{rowData.last15Minutes.streamflow}}</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].wind == true">{{rowData.last15Minutes.wind}}</span></td></tr>
			</span>
		</td>	
		<!-- Alarm Status -->		
		<td class="headerBackground">	
			<span class="table-data">
			<!-- was using when weather was per station -->
			<!-- <span class="top-line" style="visibility: hidden">empty</span> <hr> --> <!-- Specifying actual text, setting hidden, and "top-line" css allow the height of the line to match the height of the img which helps line up the horizontal rules -->
			<tr><td><span *ngIf="rowData['hasData'].rain == true" [ngClass]="rowData.alarmStatus.rainclass">{{rowData.alarmStatus.rain}}</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].waterLevel == true" [ngClass]="rowData.alarmStatus.waterLevelclass">{{rowData.alarmStatus.waterLevel}}</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].streamflow == true" [ngClass]="rowData.alarmStatus.streamflowclass">{{rowData.alarmStatus.streamflow}}</span></td></tr>
			<tr><td><span *ngIf="rowData['hasData'].wind == true" [ngClass]="rowData.alarmStatus.windclass">{{rowData.alarmStatus.wind}}</span></td></tr>
			</span>
		</td>	
		<!-- Flood Threat -->		
		<td class="headerBackground">
			<span class="table-data alarm">  <!-- if criteria changes here, modify sort criteria in station-table.component.ts -->
			<img *ngIf="rowData.alarmStatus.rainNovaScore >= 3" height="64px" width="64px" src="../assets/images/severeFloodWarning.gif">
			</span>
		</td>	
		<!-- Next 6 Hours -->		
		<td>	
			<span class="table-data">
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].rain == true">{{this.weatherInfo.next6HoursPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].waterLevel == true">{{this.weatherInfo.next6HoursPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].streamflow == true">{{this.weatherInfo.next6HoursPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].wind == true">{{this.weatherInfo.next6HoursPrecipProbability}}%</span></td></tr>
			</span>
		</td>	
		<!-- Next Day -->		
		<td>	
			<span class="table-data">
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].rain == true">{{this.weatherInfo.nextDayPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].waterLevel == true">{{this.weatherInfo.nextDayPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].streamflow == true">{{this.weatherInfo.nextDayPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].wind == true">{{this.weatherInfo.nextDayPrecipProbability}}%</span></td></tr>
			</span>
		</td>	
		<!-- Next Week -->		
		<td field="meas_count">	
			<span class="table-data">
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].rain == true">{{this.weatherInfo.nextWeekPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].waterLevel == true">{{this.weatherInfo.nextWeekPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].streamflow == true">{{this.weatherInfo.nextWeekPrecipProbability}}%</span></td></tr>
			<tr><td class='numbers'><span *ngIf="rowData['hasData'].wind == true">{{this.weatherInfo.nextWeekPrecipProbability}}%</span></td></tr>
			<!-- to hide a line:
				<span style="visibility: hidden">empty</span> -->
			</span>
		</td>		
	</tr>
</ng-template>
</p-table>
</div>

<p-dialog header="Upstream Stations" [(visible)]="dialogVisible"> <!-- showEffect="fade" [modal]="true" width="250"> -->
    <div class="ui-grid ui-grid-responsive ui-grid-pad">  <!--  *ngIf="selectedStation" -->
        <div class="ui-grid-row">
            <div class="ui-grid-col-4">ID</div>
           <!-- <div class="ui-grid-col-8" id="id">{{selectedStation.upstreamStationId}}</div> -->
        </div>
        
    </div>
</p-dialog>

